import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';

import FullNav from './FullNav';
import SlimNav from './SlimNav';
import { NavProps } from './interfaces';

const queryClient = new QueryClient();

export default function Nav({
  currentUser,
  hideSubscribeButton = false,
  isOnSubscriptionPage,
  proOfferCode,
  shouldRenderSlimNav,
  slimNavDarkModeEnabled,
  ...rest
}: NavProps) {
  return (
    <AppContextProvider initialCurrentUser={currentUser}>
      <QueryClientProvider client={queryClient}>
        {shouldRenderSlimNav ? (
          <SlimNav
            currentUser={currentUser}
            isOnSubscriptionPage={isOnSubscriptionPage}
            hideSubscribeButton={hideSubscribeButton}
            proOfferCode={proOfferCode}
            slimNavDarkModeEnabled={slimNavDarkModeEnabled}
          />
        ) : (
          <FullNav currentUser={currentUser} {...rest} />
        )}
      </QueryClientProvider>
    </AppContextProvider>
  );
}
